module.exports = Object.keys || require('./shim');




//////////////////
// WEBPACK FOOTER
// ./node_modules/object-keys/index.js
// module id = 317
// module chunks = 0